import { EnvironmentType, getEnvironmentAtRunTime } from '@cash-web/shared-util-environment'

const env = getEnvironmentAtRunTime()

// This is the application id, shared with CashApp's Local feature.
const SQUARE_CLIENT_ID_PRODUCTION = 'sq0idp-Ku4zD6g2iaYcD4OD1rpxuw'
const SQUARE_CLIENT_ID_STAGING = 'sq0ids-a8K92O-Cf_ShhPSAnbx35g'

// Square generated ID, same as Merchant Token or Location Token. This value is used by Panama when calling Esperanto to process the payment. Same in prod / staging.
const LOCATION_ID = 'FJS9X82NTJW2Z'

const SQUARE_WEB_PAYMENTS_SDK_MERCHANT_ID = '05498866192997955200'

const PCI_CONNECT_BASE_URL: Partial<Record<EnvironmentType, string>> = {
  production: 'https://pci-connect.squareup.com',
  staging: 'https://pci-connect.squareupstaging.com',
  development: '',
}

export const SQUARE_PCI_MERCHANT_VALIDATION = {
  MERCHANT_NAME: 'Cash App',
  GATEWAY: 'square',
  LOCATION_ID,
  CLIENT_ID: env === 'production' ? SQUARE_CLIENT_ID_PRODUCTION : SQUARE_CLIENT_ID_STAGING,
  MERCHANT_ID: SQUARE_WEB_PAYMENTS_SDK_MERCHANT_ID,
  APPLE_PAY_URL: `${PCI_CONNECT_BASE_URL[env]}/v2/apple-pay/validate-merchant`,
  GOOGLE_PAY_URL: `${PCI_CONNECT_BASE_URL[env]}/digital-wallets/google-pay/token`,
} as const
